/**
 * Generated by orval v6.6.4 🍺
 * Do not edit manually.
 * Customer Data Service
 * Access customer's data and estate objects
 * OpenAPI spec version: 1.0.0
 */

export type ImmobilieModernisierungModernisierungFenster = 'Keine' | 'Teilweise' | 'Komplett';

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImmobilieModernisierungModernisierungFenster = {
  Keine: 'Keine' as ImmobilieModernisierungModernisierungFenster,
  Teilweise: 'Teilweise' as ImmobilieModernisierungModernisierungFenster,
  Komplett: 'Komplett' as ImmobilieModernisierungModernisierungFenster,
};
